import {BreadCrumbs} from "../../../components/open/pages";
import {useEffect, useState} from "react";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {HideProgressLoading} from "../../../components/template/architecture";
import {Link, useNavigate} from "react-router-dom";
import {ThinArrowLeft, ThinChatIcon, ThinChatUnreadIcon} from "../../../components/icons/material-icons";
import '../../../static/css/pages/ticket/ticket.css';
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {ShowSnackbar} from "../../../components/template/snackbar";

interface ticketInterface {
    nd: string,
    title: string,
    studentId: number,
    studentName: string,
    createdAt: string,
    isClosed: 0 | 1,
    closedAt: string,
}

export const AdminTicketsScreen = () => {
    const [list, setList] = useState<ticketInterface[]>([]);
    const [loaded, setLoaded] = useState(false);
    const navigate = useNavigate();
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/admins/tickets/list',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: ticketInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if(d.reason === 'access'){
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                        navigate('/admins',{replace:true});
                    }
                    return;
                }
                setList(d.list === null ? [] : d.list);
                setLoaded(true);
            },
            () => {
                ShowConnectionFailed('fa');
                HideProgressLoading();
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "تیکت‌ها | نهال";
        fetchList();
    }, []);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'تیکت', url: '/admins/tickets'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>تیکت‌ها</b>
                            </div>
                            {
                                list.map((t, i) =>
                                    <Link to={`/admins/tickets/view/${t.nd}`}
                                          key={"J39fFk39Dkl3"+i}
                                          className={'ticket-item' + (t.isClosed === 0 ? ' ticket-item-closed' : '')}>
                                        <div>
                                            <i>{t.isClosed === 0 ? <ThinChatUnreadIcon/> : <ThinChatIcon/>}</i>
                                            <div>
                                                <b className={"max-lines-1"}>{t.title}</b>
                                                <span>توسط {t.studentName} در تاریخ {StringDigitsConvertToPersian(GregorianToPersian(t.createdAt).replaceAll('-','/'))} و ساعت {StringDigitsConvertToPersian(t.createdAt.split(' ')[1])} - {t.isClosed === 1 ? 'بسته شده' : 'در انتظار پاسخ'}</span>
                                            </div>
                                        </div>
                                        <ThinArrowLeft/>
                                    </Link>
                                )
                            }
                        </div>
                    </div> : null
            }
        </>
    );
};